
import { styleNumPxToVm as vm } from '@/shared/utils/style-unit';
import { Vue, Component, Prop } from 'vue-property-decorator';

import styles from './index.module.scss';

const baseImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAQSURBVHgBAQUA+v8A8PP1/wmHA9gKJVfHAAAAAElFTkSuQmCC';

@Component({ name: 'LoadingSkeleton' })
export default class LoadingSkeleton extends Vue {
  @Prop() private width!: number;

  @Prop() private height!: number;

  @Prop() private radius!: number;

  private render() {
    const { width, height, radius = 4 } = this;
    return (
      <div class={styles.loadingSkeleton} style={{ width: `${vm(width)}vw`, height: `${vm(height)}vw`, borderRadius: `${vm(radius)}vw` }}>
        <img src={baseImg} />
      </div>
    );
  }
}
